import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";

import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import SVG from "react-inlinesvg";
import { formatDate, sizePerPageList } from "../../utility";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useHistory } from "react-router";
import { selectUser } from "../../modules/Auth/_redux/authRedux";

// import Pagination from 'react-bootstrap/Pagination'

export const NeedAppovalTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const [tableData, setTableData] = useState(data);
  const history = useHistory();
  const user = useSelector(selectUser);

  const role = user.roles.map((e) => {
    return e.roleName;
  });
  const permisionRole = role.toString();
  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);

    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,

      };
    });

    setTableData(initData);
  }, [data, sizePerPage, page]);

  const detailsAllowed = [
    "ADMIN",
    "ADMINISTRATOR",
    "OPERATION_HO",
    "ASM",
    "NSM",
    "BM",
    "QAHO",
    "BRQA",
    "CHIEF_DELIVERY",
    "CHIEF_WAREHOUSE",
    "CLIENT",
    "FSS",
  ];

  const checkRoles = (userRoles, allowedRoles) => {
    return userRoles.some((e) => allowedRoles.includes(e));
  };

  const columns = [
    {
      dataField: "no",
      text: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "ret_number",
      text: "APL Return Number ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "invoice_ref_no",
      text: "invoice ref no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "customer_name",
      text: "Customer Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "material_name",
      text: "Material Desc",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "pending_user",
      text: "Pending User",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "created_date",
      text: "created date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
    },

    {
      dataField: "detail",
      text: "Detail",
      formatter: (cell, row) => (
        <div>
          {checkRoles(role, detailsAllowed) && (
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}
            >
              <a
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                // onClick={(e) =>
                //   history.push("/report-return/report-header", {
                //     params: row.ret_number
                //   })
                // }
                onClick={(e) => {
                  if (row.step_code === "SALES") {
                    history.push(`/fss-asm-bm/${row.ret_number}`, {
                      params: row.ret_number,
                    });
                  } else if (row.step_code === "BRQA") {
                    history.push(`/brqa/${row.ret_number}`, {
                      params: row.ret_number,
                    });
                  } else if (row.step_code === "QAHO") {
                    history.push(`/qa-ho/${row.ret_number}`, {
                      params: row.ret_number,
                    });
                  } else if (row.step_code === "CLIENT") {
                    history.push(`/client/${row.ret_number}`, {
                      params: row.ret_number,
                    });
                  } else if (row.step_code === "CD") {
                    history.push(`/chief-delivery/${row.ret_number}`, {
                      params: row.ret_number,
                    });
                  } else if (row.step_code === "CW") {
                    history.push(`/chief-warehouse/${row.ret_number}`, {
                      params: row.ret_number,
                    });
                  } else {
                    history.push(
                      `/report-return/report-header/${row.ret_number}`,
                      {
                        params: row.ret_number,
                      }
                    );
                  }
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Write.svg"
                    )}
                  />
                </span>
              </a>
            </OverlayTrigger>
          )}
        </div>
      ),
    },
  ];
  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="no"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        noDataIndication="New Registration is Empty"
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
